/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { useState, useEffect } from "react";

export const useMediaQuery = (query: string): boolean => {
	const [matches, setMatches] = useState(false);

	useEffect(() => {
		const mediaQuery = window.matchMedia(query);

		if (!mediaQuery || typeof mediaQuery.matches === "undefined") {
			setMatches(false);
		} else {
			setMatches(mediaQuery.matches);
		}

		const handleChange = (): void => {
			setMatches(mediaQuery?.matches || false);
		};

		mediaQuery?.addEventListener("change", handleChange);

		return () => {
			mediaQuery?.removeEventListener("change", handleChange);
		};
	}, [query]);

	if (!query) return false;

	return matches;
};
